import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '../components/primitives/index.js'
import InvoiceDocument from '../components/InvoiceDocument.jsx'
import SEO from '../components/SEO.jsx'
import { useCustomer } from '../context/CustomerContext.jsx'
import { useProducts } from '../context/ProductsContext.jsx'
import { applySeoOverrides } from '../config/seo.js'
import './OrderConfirmPage.css'

function CreateAccountPrompt({ email }) {
  const href = `/account/register${email ? `?email=${encodeURIComponent(email)}` : ''}`
  return (
    <div className="invoice-no-print order-confirm__prompt">
      <p className="order-confirm__prompt-title">Want to track this order easily?</p>
      <p className="order-confirm__prompt-body">Create an account to see order history, save addresses, and earn rewards on future orders.</p>
      <Button to={href} variant="primary">
        Create an account
      </Button>
    </div>
  )
}

/**
 * Mirrors Prod's /order-confirm contract exactly: reads the order from
 * navigate() state (not a route param), so a hard refresh loses it — that's
 * intentional, this page is one-shot right after checkout. Mounted outside
 * <Layout/> (see App.jsx) so there's no site nav/footer around the invoice.
 */
export default function OrderConfirmPage() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const { customer } = useCustomer()
  const { checkoutConfig, preorderMessage, seoSettings } = useProducts()

  const order = state?.order
  const email = state?.email

  useEffect(() => {
    if (!order) navigate('/', { replace: true })
  }, [order, navigate])

  if (!order) return null

  return (
    <div className="order-confirm">
      <SEO config={applySeoOverrides({ title: 'Order Confirmed', robots: 'noindex, nofollow', titleRaw: true }, seoSettings?.pages?.orderConfirm)} />
      <InvoiceDocument
        order={order}
        activeConfig={checkoutConfig}
        isFresh
        email={email}
        showDiscord
        preorderMessage={order.items?.some((i) => i.preorder) ? preorderMessage : null}
      />
      {!customer && <CreateAccountPrompt email={email} />}
    </div>
  )
}
